module.exports = __webpack_public_path__ + "static/media/fj.7cc3769d.svg";